interface ITranslationFileMapping {
  [key: string]: string[]
}

export const LanguageFileLocations: ITranslationFileMapping = {
  Auth: [
    "Access",
    "Login",
    "PasswordRequest",
    "ResetPassword",
    "UserInviteRegister",
  ],
  Client: [
    "ClientAccount",
    "ClientBusinessNumbers",
    "ImapAccount",
    "MyAccount",
    "SystemSettings",
  ],
  Components: [
    "Avatar",
    "Buttons",
    "ModalInvoiceEmail",
    "ModalInvoiceReminderEmail",
    "List",
    "Operator",
    "SystemNav",
  ],
  ComponentsForm: [
    "InputDropdown",
    "InputSelect",
  ],
  ContentGrid: [
    "LayoutTabs",
    "Widget",
    "WidgetItems",
    "WidgetSettings",
  ],
  ContentGridWidgets: [
    "Address",
    "BankAccount",
    "BusinessNumbers",
    "CompanyContactPerson",
    "CompanyInfo",
    "CompanyList",
    "CompanySearch",
    "CompanyRelation",
    "DashboardCompanyTotal",
    "DashboardInvoiceAction",
    "DashboardPersonTotal",
    "DashboardYearlyChart",
    "DossierSearch",
    "EmailAddress",
    "EntityConnection",
    "InvoiceInvoice",
    "InvoiceItem",
    "InvoiceList",
    "InvoiceSearch",
    "InvoiceTarget",
    "LayoutAddWidgetTitle",
    "PersonContactPerson",
    "PersonInfo",
    "PersonList",
    "PersonNumbers",
    "PersonSearch",
    "PhoneNumber",
  ],
  ContentSettings: [
    "InvoiceSettings",
  ],
  Data: [
    "AddressType",
    "City",
    "ConnectionType",
    "Currency",
    "EmailAddressType",
    "InvoiceStatus",
    "PhoneNumberType",
  ],
  Header: [
    "HeaderNav",
  ],
  Module: [
    "Address",
    "BankAccount",
    "ClientSettings",
    "Company",
    "CompanyContactPerson",
    "CompanyRelationCompany",
    "Dashboard",
    "Dossier",
    "EmailAddress",
    "Entity",
    "Invoice",
    "InvoiceItem",
    "Layout",
    "Module",
    "Modules",
    "Person",
    "PhoneNumber",
    "Product",
  ],
  System: [
    "Settings",
    "SystemLayout",
  ],
  Toolbar: [
    "ImapSync",
    "Layout",
    "ModuleCompany",
    "ModuleInvoice",
    "ModulePerson",
    "SettingsLayouts",
  ],
  Util: [
    "Months",
  ],
}
